import React from 'react';
import { motion } from 'framer-motion';
import { SlideStage } from '../../components/deck/SlideStage';
import { VexuCallDetailShowcase } from '../../components/deck/VexuCallDetailShowcase';
import { proofPoints, productCallouts } from '../../data/deckSlide4';
const VEXU_LOGO = 'https://cdn.magicpatterns.com/uploads/3A8d459aXLumR8KKFCQtrD/vexu_logo.svg';
const CALENDAR_ICONS: Record<string, string> = {
  'Google Calendar': 'https://upload.wikimedia.org/wikipedia/commons/a/a5/Google_Calendar_icon_%282020%29.svg',
  'Outlook Calendar': 'https://upload.wikimedia.org/wikipedia/commons/d/df/Microsoft_Office_Outlook_%282018%E2%80%93present%29.svg'
};
const ease = [0.22, 0.61, 0.36, 1] as const;
const T = {
  headline: 0.2,
  support: 0.9,
  phone: 1.3,
  proof: 2.2,
  callouts: 3.0
};
export function ProductExperienceSlide() {
  return <SlideStage data-id="element-2596" data-mp="2qver7n8cut67">
      <div className="deck-type absolute inset-0 overflow-hidden bg-[#FAFCF9]" data-id="element-2597" data-mp="2lu8y3oas93w5">
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse 90% 70% at 8% -18%, rgba(0,200,83,0.06) 0%, rgba(250,252,249,0) 60%), radial-gradient(ellipse 55% 60% at 66% 45%, rgba(0,200,83,0.09) 0%, rgba(250,252,249,0) 68%), linear-gradient(180deg, #FBFDFA 0%, #F5F8F3 55%, #EFF3ED 100%)'
      }} data-id="element-2598" data-mp="2lwbxgyxts9dj" />

        {/* Brand header */}
        <motion.div className="absolute flex items-center gap-3" style={{
        left: 112,
        top: 56
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease
      }} data-id="element-2599" data-mp="295c6b3b885qi">
          <img src={VEXU_LOGO} alt="" className="w-7 h-7 object-contain" data-id="element-2600" data-mp="203m555rjlsfj" />
          <span className="text-[16px] font-bold tracking-tight text-[#0B1712]" data-id="element-2601" data-mp="2538si8134p22">
            Vexu.ai
          </span>
        </motion.div>
        <motion.span className="absolute text-[11px] font-semibold uppercase tracking-[0.28em] text-[#8A998F]" style={{
        right: 112,
        top: 62
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease
      }} data-id="element-2602" data-mp="onxfu7qtghbk">
          04 · Product Experience
        </motion.span>

        {/* LEFT — the claim */}
        <h1 className="absolute text-[46px] font-semibold leading-[1.16] tracking-[-0.02em] text-[#0B1712]" style={{
        left: 112,
        top: 190,
        width: 560
      }} data-id="element-2603" data-mp="2lmwd27sucmgw">
          {['Every call becomes', 'context you can act on.'].map((line, i) => <motion.span key={line} className="block" initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: T.headline + i * 0.16,
          ease
        }} data-id="element-2604" data-mp="27o6hiwlo6uun" data-mpi={i}>
              {line}
            </motion.span>)}
        </h1>

        <motion.p className="absolute text-[18px] leading-relaxed text-[#5A6B60]" style={{
        left: 112,
        top: 326,
        width: 480
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: T.support,
        ease
      }} data-id="element-2605" data-mp="wp7tes5pgo7">
          Not just who called — why they called, what happened, and what comes
          next.
        </motion.p>

        <div className="absolute" style={{
        left: 112,
        top: 452,
        width: 420
      }} data-id="element-2606" data-mp="1okuv2q18i1n0">
          {proofPoints.map((point, i) => <motion.div key={point.label} className="border-t border-[#0B1712]/[0.09] py-5" initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: T.proof + i * 0.2,
          ease
        }} data-id="element-2607" data-mp="1skde1g9hw2n7" data-mpi={i}>
              <p className="text-[11px] font-semibold uppercase tracking-[0.26em] text-vexu-700/80" data-id="element-2608" data-mp="14xou6p0xe03y">
                {point.label}
              </p>
              <p className="mt-2 text-[20px] font-medium tracking-[-0.01em] text-[#0B1712]" data-id="element-2609" data-mp="2gbiv1yr690z3">
                {point.detail}
              </p>
            </motion.div>)}
        </div>

        {/* RIGHT — the real completed call */}
        <motion.div className="absolute" style={{
        left: 830,
        top: 108
      }} initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: T.phone,
        ease
      }} data-id="element-2610" data-mp="2jsx5gu57yydj">
          <VexuCallDetailShowcase scale={0.78} data-id="element-2611" data-mp="2or8fp5zffawa" />
        </motion.div>

        {/* Restrained index of what is on screen */}
        <div className="absolute border-l border-[#0B1712]/10 pl-6" style={{
        left: 1250,
        top: 250
      }} data-id="element-2612" data-mp="32qhkl9i6miky">
          {productCallouts.map((callout, i) => <motion.div key={callout.label} className="mb-8 last:mb-0" initial={{
          opacity: 0,
          x: -6
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.7,
          delay: T.callouts + i * 0.18,
          ease
        }} data-id="element-2613" data-mp="3chlxm3oartd5" data-mpi={i}>
              <p className="text-[11px] font-semibold tracking-[0.24em] text-vexu-600/70 tabular-nums" data-id="element-2614" data-mp="3gj7es17v6tt5">
                {String(i + 1).padStart(2, '0')}
              </p>
              <p className="mt-1.5 text-[15px] font-medium text-[#33463B]" data-id="element-2615" data-mp="3xikvg8he10b">
                {callout.label}
              </p>
              {callout.integrations && <motion.div className="mt-2 flex items-center gap-2" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: T.callouts + i * 0.18 + 0.35,
            ease
          }} data-id="element-2616" data-mp="3r3hwlma6od9u">
                  {callout.integrations.map(name => <span key={name} className="inline-flex items-center gap-1.5 text-[11.5px] text-[#8A998F]" data-id="element-2617" data-mp="37dz4ehi88p12">
                      <img src={CALENDAR_ICONS[name]} alt="" className="h-[13px] w-[13px] object-contain" data-id="element-2618" data-mp="2yfvukigltgp3" />
                      {name.replace(' Calendar', '')}
                    </span>)}
                </motion.div>}
            </motion.div>)}

          <motion.p className="mt-9 text-[12.5px] text-[#8A998F]" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: T.callouts + 1.1,
          ease
        }} data-id="element-2619" data-mp="z9gp7bwukwzv">
            Connected to the tools you already use.
          </motion.p>
        </div>
      </div>
    </SlideStage>;
}